import { forwardRef, useImperativeHandle } from "react";
import { Card } from "@components/shadcn-ui/card";
import { DynamicFormField } from "@components/ui/DynamicInput";
import { APPROVED_LOAN_DETAILS } from "features/loanApplications/formFieldsConfig/ApproveLoanDetails";
import { useForm, FormProvider } from "react-hook-form";

export interface ApprovedLoanSectionRef {
  submitForm: () => Promise<void>;
}

interface ApprovedLoanSectionProps {
  onSubmitSuccess: (data: any) => void;
}

export const ApprovedLoanSection = forwardRef<
  ApprovedLoanSectionRef,
  ApprovedLoanSectionProps
>(({ onSubmitSuccess }, ref) => {
  const formMethods = useForm();

  const onSubmit = async (data: any) => {
    const isValid = await formMethods.trigger();
    console.log("isValid", isValid);
    if (isValid) {
      console.log("Form Data:", data);
      onSubmitSuccess(data);
    }
  };

  useImperativeHandle(ref, () => ({
    submitForm: async () => {
      await formMethods.handleSubmit(onSubmit)();
    },
  }));

  return (
    <>
      <strong className="block mb-2 text-md bg-[#bbd0ce] p-2 pl-4 rounded-sm mt-5">
        Approved loan details
      </strong>
      <Card>
        <FormProvider {...formMethods}>
          <form onSubmit={formMethods.handleSubmit(onSubmit)}>
            <div className="flex flex-wrap p-4 gap-5">
              {APPROVED_LOAN_DETAILS.fields.map((field) => (
                <div className="basis-[45%]" key={field.name}>
                  <DynamicFormField field={field} isDisabled={false} />
                </div>
              ))}
            </div>
          </form>
        </FormProvider>
      </Card>
    </>
  );
});
